module.exports = __webpack_public_path__ + "img/user-roles.d6b79116.svg";